import {
  Component,
  OnDestroy,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import { StockChangeRecord } from '../../../change/stock-change.config';
import { StockItem } from '../../../search/stock-search.config';
import { TransferItem } from '../transfer.config';
import { LogicTransferItem } from '../../logic/logic-transfer.config';
import {
  StockDeliveryRecord,
  StockDeliveryResultRecord,
} from '../../../delivery/stock-delivery.config';
import {
  AddFormComponent,
  FormField,
} from '@shared/components/add-form/add-form.component';

export interface StockViewData {
  type:
    | 'change'
    | 'search'
    | 'delivery-inform'
    | 'delivery-result'
    | 'transfer'
    | 'logic-transfer';
  data:
    | StockChangeRecord
    | StockItem
    | StockDeliveryRecord
    | StockDeliveryResultRecord
    | TransferItem
    | LogicTransferItem;
}

@Component({
  selector: 'app-stock-view',
  standalone: true,
  imports: [CommonModule, ButtonModule, AddFormComponent, TranslateModule],
  templateUrl: './stock-view.component.html',
  styleUrl: './stock-view.component.css',
})
export class StockViewComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  // Input properties - all data comes from parent
  @Input() viewData: StockViewData | null = null;
  @Input() loading = false;
  @Input() pageTitle = 'Stock Details';
  @Input() formFields: FormField[] = [];
  @Input() formData: any = {};

  // Output events - parent handles navigation
  @Output() backClick = new EventEmitter<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFormAction(event: { action: string; data?: any }): void {
    if (event.action === 'cancel') {
      this.backClick.emit();
    }
  }

  onBack(): void {
    this.backClick.emit();
  }
}
